import { render, staticRenderFns } from "./CMBody.vue?vue&type=template&id=247c8dad&scoped=true&lang=pug"
import script from "./CMBody.vue?vue&type=script&lang=js"
export * from "./CMBody.vue?vue&type=script&lang=js"
import style0 from "./CMBody.vue?vue&type=style&index=0&id=247c8dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c8dad",
  null
  
)

export default component.exports